<template>
  <div
    class="team section"
    :style="sectionStyle"
  >
    <div class="container flex column items-center">
      <div
        v-if="title"
        class="text-center q-mb-md"
        :style="titleStyle"
      >
        {{ title }}
      </div>
      <div
        v-if="description"
        :style="descriptionStyle"
        class="description text-center q-mb-lg"
      >
        {{ description }}
      </div>

      <div class="row">
        <TeamItem
          v-for="(item, index) in items"
          :key="index"
          v-bind="item"
          :label-style="labelStyle"
          :sublabel-style="sublabelStyle"
          class="col q-px-lg"
        />
      </div>

    </div>
  </div>
</template>

<script>
import TeamItem from './TeamItem';
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';
import labelMixin from './mixins/labelMixin';
import sublabelMixin from './mixins/sublabelMixin';
import titleMixin from './mixins/titleMixin';

export default {
  name: 'TeamSection',
  components: { TeamItem },
  mixins: [backgroundMixin, titleMixin, descriptionMixin, labelMixin, sublabelMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.team {
  .description {
    max-width: 600px;
  }

}
</style>
